/**
 * @file specialty.schema.ts
 * @description Define o schema Zod para a entidade 'Specialty'.
 * Uma Especialidade é uma área de atuação da saúde (ex: Ginecologia),
 * gerenciada de forma centralizada para garantir a consistência dos dados.
 */

import { z } from 'zod';

// --- Main Specialty Schema ---

const SpecialtySchema = z.object({
  // Nome de exibição da especialidade. Ex: "Ginecologia e Obstetrícia".
  name: z.string(),
  
  // Opcional: uma breve descrição sobre a especialidade.
  description: z.string().optional(),

  // Campos de auditoria.
  createdAt: z.date(),
  updatedAt: z.date(),
  deletedAt: z.date().nullable(),
});


// --- Inferred TypeScript Types ---

type Specialty = z.infer<typeof SpecialtySchema>;


// --- Public Exports ---

export { SpecialtySchema };
export type { Specialty };